import { v4 as uuid } from 'uuid'
import { TCommandParamsIfExists } from '../interfaces/command/CommandTypeUtils'
import { AsyncExecutableCmd } from '../interfaces/command/AsyncExecutableCmd'
import { AsyncCmdExecuteFunction } from '../interfaces/command/AsyncCmdExecuteFunction'
/**
 *
 */
export class AsyncExecutableCommand<
  T,
  K extends keyof T,
  E
  > implements AsyncExecutableCmd<T, K, E> {
  public readonly commandName: K;

  public readonly id: string

  public readonly params?: TCommandParamsIfExists<T, K>;

  private execFn: AsyncCmdExecuteFunction<T, K, E>;

  private execCount = 0

  /**
   *
   * @param arg
   */
  constructor(arg: {
    command: K;
    params?: TCommandParamsIfExists<T, K>;
    execFn: AsyncCmdExecuteFunction<T, K, E>;
  }) {
    this.commandName = arg.command
    this.params = arg.params
    this.execFn = arg.execFn
    this.id = uuid()
  }

  public async exec() {
    this.execCount += 1
    const res = await this.execFn()
    return res
  }
}
